const globeDestinations = [
 {
    "id": "india",
    "title": "India",
    "lat": 20.5937,
    "lng": 78.9629,
    "summary": "A vibrant land of culture, heritage and nature."
  },
  {
    "id": "france",
    "title": "France",
    "lat": 46.6034,
    "lng": 1.8883,
    "summary": "The romantic hub of wine, art and Eiffel Tower!"
  },
  {
    "id": "sri-lanka",
    "title": "Sri Lanka",
    "lat": 7.8731,
    "lng": 80.7718,
    "summary": "An island nation known for its beaches, tea, and ancient ruins."
  },
  {
    "id": "thailand",
    "title": "Thailand",
    "lat": 15.8700,
    "lng": 100.9925,
    "summary": "The land of smiles, tropical beaches, and rich culture."
  },
  {
    "id": "vietnam",
    "title": "Vietnam",
    "lat": 14.0583,
    "lng": 108.2772,
    "summary": "Famous for its cuisine, landscapes, and history."
  },
  {
    "id": "usa",
    "title": "United States",
    "lat": 37.0902,
    "lng": -95.7129,
    "summary": "A diverse country known for innovation, culture, and landscapes."
  },
  {
    "id": "canada",
    "title": "Canada",
    "lat": 56.1304,
    "lng": -106.3468,
    "summary": "Land of lakes, forests, and multicultural cities."
  },
  {
    "id": "brazil",
    "title": "Brazil",
    "lat": -14.2350,
    "lng": -51.9253,
    "summary": "Famous for the Amazon, carnivals, and football."
  },
  {
    "id": "japan",
    "title": "Japan",
    "lat": 36.2048,
    "lng": 138.2529,
    "summary": "A blend of tradition and futuristic technology."
  },
  {
    "id": "australia",
    "title": "Australia",
    "lat": -25.2744,
    "lng": 133.7751,
    "summary": "Home to the Outback, Great Barrier Reef, and beaches."
  },
  {
    "id": "italy",
    "title": "Italy",
    "lat": 41.8719,
    "lng": 12.5674,
    "summary": "A treasure trove of art, cuisine, and ancient history."
  },
  {
    "id": "germany",
    "title": "Germany",
    "lat": 51.1657,
    "lng": 10.4515,
    "summary": "Known for precision, culture, and scenic landscapes."
  },
  {
    "id": "spain",
    "title": "Spain",
    "lat": 40.4637,
    "lng": -3.7492,
    "summary": "Famous for fiestas, flamenco, and stunning architecture."
  },
  {
    "id": "china",
    "title": "China",
    "lat": 35.8617,
    "lng": 104.1954,
    "summary": "Ancient civilization with rapid modern growth."
  },
  {
    "id": "south-africa",
    "title": "South Africa",
    "lat": -30.5595,
    "lng": 22.9375,
    "summary": "A country of wildlife, wine, and diverse cultures."
  },
  {
    "id": "egypt",
    "title": "Egypt",
    "lat": 26.8206,
    "lng": 30.8025,
    "summary": "Land of Pharaohs, pyramids, and the Nile."
  },
  {
    "id": "turkey",
    "title": "Turkey",
    "lat": 38.9637,
    "lng": 35.2433,
    "summary": "Where East meets West with rich history."
  },
  {
    "id": "argentina",
    "title": "Argentina",
    "lat": -38.4161,
    "lng": -63.6167,
    "summary": "Known for tango, steak, and Patagonia."
  },
  {
    "id": "indonesia",
    "title": "Indonesia",
    "lat": -0.7893,
    "lng": 113.9213,
    "summary": "An archipelago of volcanoes, beaches, and culture."
  },
  {
    "id": "mexico",
    "title": "Mexico",
    "lat": 23.6345,
    "lng": -102.5528,
    "summary": "Land of tacos, Mayan ruins, and vibrant festivals."
  },
  {
    "id": "united-kingdom",
    "title": "United Kingdom",
    "lat": 55.3781,
    "lng": -3.4360,
    "summary": "A blend of monarchy, history, and innovation."
  },
  {
    "id": "portugal",
    "title": "Portugal",
    "lat": 39.3999,
    "lng": -8.2245,
    "summary": "Famous for explorers, seafood, and scenic coasts."
  },
  {
    "id": "malaysia",
    "title": "Malaysia",
    "lat": 4.2105,
    "lng": 101.9758,
    "summary": "A melting pot of cultures and natural wonders."
  },
  {
    "id": "netherlands",
    "title": "Netherlands",
    "lat": 52.1326,
    "lng": 5.2913,
    "summary": "Known for canals, tulips, and cycling."
  },
  {
    "id": "switzerland",
    "title": "Switzerland",
    "lat": 46.8182,
    "lng": 8.2275,
    "summary": "Famous for mountains, chocolate, and neutrality."
  },
  {
    "id": "norway",
    "title": "Norway",
    "lat": 60.4720,
    "lng": 8.4689,
    "summary": "A land of fjords, auroras, and Viking legacy."
  },
  {
    "id": "sweden",
    "title": "Sweden",
    "lat": 60.1282,
    "lng": 18.6435,
    "summary": "Innovative, scenic, and culturally rich."
  },
  {
    "id": "finland",
    "title": "Finland",
    "lat": 61.9241,
    "lng": 25.7482,
    "summary": "Land of lakes, saunas, and northern lights."
  },
  {
    "id": "denmark",
    "title": "Denmark",
    "lat": 56.2639,
    "lng": 9.5018,
    "summary": "A happy nation of design and sustainability."
  },
  {
    "id": "poland",
    "title": "Poland",
    "lat": 51.9194,
    "lng": 19.1451,
    "summary": "Rich in history, resilience, and architecture."
  },
  {
    "id": "uae",
    "title": "UAE",
    "lat": 23.4241,
    "lng": 53.8478,
    "summary": "Luxury meets tradition in the desert."
  },
  {
    "id": "qatar",
    "title": "Qatar",
    "lat": 25.276987,
    "lng": 51.520008,
    "summary": "Modern architecture and Arabian heritage."
  },
  {
    "id": "saudi-arabia",
    "title": "Saudi Arabia",
    "lat": 23.8859,
    "lng": 45.0792,
    "summary": "Deserts, oil wealth, and Islamic history."
  },
  {
    "id": "nepal",
    "title": "Nepal",
    "lat": 28.3949,
    "lng": 84.1240,
    "summary": "Gateway to the Himalayas and spirituality."
  },
  {
    "id": "bhutan",
    "title": "Bhutan",
    "lat": 27.5142,
    "lng": 90.4336,
    "summary": "The land of happiness and Himalayan beauty."
  },
  {
    "id": "afghanistan",
    "title": "Afghanistan",
    "lat": 33.9391,
    "lng": 67.7100,
    "summary": "Mountainous landscapes and rich cultural heritage."
  },
  {
    "id": "albania",
    "title": "Albania",
    "lat": 41.1533,
    "lng": 20.1683,
    "summary": "Mediterranean beaches and ancient ruins."
  },
  {
    "id": "algeria",
    "title": "Algeria",
    "lat": 28.0339,
    "lng": 1.6596,
    "summary": "Sahara deserts and diverse cultures."
  },
  {
    "id": "andorra",
    "title": "Andorra",
    "lat": 42.5462,
    "lng": 1.6016,
    "summary": "A mountainous microstate nestled in the Pyrenees."
  },
  {
    "id": "angola",
    "title": "Angola",
    "lat": -11.2027,
    "lng": 17.8739,
    "summary": "Rich in natural resources and cultural diversity."
  },
  {
    "id": "antigua-and-barbuda",
    "title": "Antigua and Barbuda",
    "lat": 17.0608,
    "lng": -61.7964,
    "summary": "Twin-island nation known for reef-lined beaches."
  },
  {
    "id": "argentina",
    "title": "Argentina",
    "lat": -38.4161,
    "lng": -63.6167,
    "summary": "Tango, Pampas, and Patagonian landscapes."
  },
  {
    "id": "armenia",
    "title": "Armenia",
    "lat": 40.0691,
    "lng": 45.0382,
    "summary": "Ancient monasteries and mountainous terrain."
  },
  {
    "id": "austria",
    "title": "Austria",
    "lat": 47.5162,
    "lng": 14.5501,
    "summary": "Alpine beauty and classical music heritage."
  },
  {
    "id": "azerbaijan",
    "title": "Azerbaijan",
    "lat": 40.1431,
    "lng": 47.5769,
    "summary": "Caspian Sea coastline and rich history."
  },
  {
    "id": "bahamas",
    "title": "Bahamas",
    "lat": 25.0343,
    "lng": -77.3963,
    "summary": "Tropical paradise with clear blue waters."
  },
  {
    "id": "bahrain",
    "title": "Bahrain",
    "lat": 26.0667,
    "lng": 50.5577,
    "summary": "Island nation with rich history and modern skyline."
  },
  {
    "id": "bangladesh",
    "title": "Bangladesh",
    "lat": 23.6850,
    "lng": 90.3563,
    "summary": "Lush greenery and vibrant culture."
  },
  {
    "id": "barbados",
    "title": "Barbados",
    "lat": 13.1939,
    "lng": -59.5432,
    "summary": "Caribbean island known for beaches and festivals."
  },
  {
    "id": "belarus",
    "title": "Belarus",
    "lat": 53.7098,
    "lng": 27.9534,
    "summary": "Landlocked country with rich forests and history."
  },
  {
    "id": "belgium",
    "title": "Belgium",
    "lat": 50.5039,
    "lng": 4.4699,
    "summary": "Known for medieval towns and Renaissance architecture."
  },
  {
    "id": "belize",
    "title": "Belize",
    "lat": 17.1899,
    "lng": -88.4976,
    "summary": "Caribbean beaches and Mayan ruins."
  },
  {
    "id": "benin",
    "title": "Benin",
    "lat": 9.3077,
    "lng": 2.3158,
    "summary": "West African nation with rich traditions."
  },
  {
    "id": "bhutan",
    "title": "Bhutan",
    "lat": 27.5142,
    "lng": 90.4336,
    "summary": "Himalayan kingdom known for its monasteries."
  },
  {
    "id": "bolivia",
    "title": "Bolivia",
    "lat": -16.2902,
    "lng": -63.5887,
    "summary": "Andean peaks and diverse cultures."
  },
  {
    "id": "bosnia-and-herzegovina",
    "title": "Bosnia and Herzegovina",
    "lat": 43.9159,
    "lng": 17.6791,
    "summary": "Balkan country with medieval villages and rivers."
  },
  {
    "id": "botswana",
    "title": "Botswana",
    "lat": -22.3285,
    "lng": 24.6849,
    "summary": "Known for the Okavango Delta and wildlife."
  },
  {
    "id": "brunei",
    "title": "Brunei",
    "lat": 4.5353,
    "lng": 114.7277,
    "summary": "Small nation on Borneo with wealth from oil."
  },
  {
    "id": "bulgaria",
    "title": "Bulgaria",
    "lat": 42.7339,
    "lng": 25.4858,
    "summary": "Black Sea coastline and mountainous interior."
  },
  {
    "id": "burkina-faso",
    "title": "Burkina Faso",
    "lat": 12.2383,
    "lng": -1.5616,
    "summary": "Landlocked country in West Africa."
  },
  {
    "id": "burundi",
    "title": "Burundi",
    "lat": -3.3731,
    "lng": 29.9189,
    "summary": "Small nation with rolling hills and lakes."
  },
  {
    "id": "cambodia",
    "title": "Cambodia",
    "lat": 12.5657,
    "lng": 104.9910,
    "summary": "Home to Angkor Wat and rich history."
  },
  {
    "id": "cameroon",
    "title": "Cameroon",
    "lat": 7.3697,
    "lng": 12.3547,
    "summary": "Diverse landscapes from beaches to mountains."
  },
  {
    "id": "cape-verde",
    "title": "Cape Verde",
    "lat": 16.5388,
    "lng": -23.0418,
    "summary": "Island nation with Creole Portuguese-African culture."
  },
  {
    "id": "central-african-republic",
    "title": "Central African Republic",
    "lat": 6.6111,
    "lng": 20.9394,
    "summary": "Landlocked country with diverse wildlife."
  },
  {
    "id": "chad",
    "title": "Chad",
    "lat": 15.4542,
    "lng": 18.7322,
    "summary": "Sahara landscapes and rich cultural heritage."
  },
  {
    "id": "chile",
    "title": "Chile",
    "lat": -35.6751,
    "lng": -71.5430,
    "summary": "Long coastline with deserts and glaciers."
  },
  {
    "id": "colombia",
    "title": "Colombia",
    "lat": 4.5709,
    "lng": -74.2973,
    "summary": "Coffee plantations and Caribbean beaches."
  },
  {
    "id": "comoros",
    "title": "Comoros",
    "lat": -11.6455,
    "lng": 43.3333,
    "summary": "Island nation with volcanic islands."
  },
  {
    "id": "congo",
    "title": "Congo",
    "lat": -0.2280,
    "lng": 15.8277,
    "summary": "Rainforests and diverse wildlife."
  },
  {
    "id": "costa-rica",
    "title": "Costa Rica",
    "lat": 9.7489,
    "lng": -83.7534,
    "summary": "Rainforests, beaches, and biodiversity."
  },
  {
    "id": "croatia",
    "title": "Croatia",
    "lat": 45.1000,
    "lng": 15.2000,
    "summary": "Adriatic coastlines and medieval towns."
  },
  {
    "id": "cuba",
    "title": "Cuba",
    "lat": 21.5218,
    "lng": -77.7812,
    "summary": "Caribbean island with rich history and culture."
  },
  {
    "id": "cyprus",
    "title": "Cyprus",
    "lat": 35.1264,
    "lng": 33.4299,
    "summary": "Mediterranean island with ancient ruins."
  },
  {
    "id": "czech-republic",
    "title": "Czech Republic",
    "lat": 49.8175,
    "lng": 15.4730,
    "summary": "Historic castles and medieval towns."
  },
  {
    "id": "democratic-republic-of-the-congo",
    "title": "Democratic Republic of the Congo",
    "lat": -4.0383,
    "lng": 21.7587,
    "summary": "Vast rainforests and rich mineral resources."
  },
  {
    "id": "djibouti",
    "title": "Djibouti",
    "lat": 11.8251,
    "lng": 42.5903,
    "summary": "Strategic port country with volcanic landscapes and salt lakes."
  },
  {
    "id": "dominica",
    "title": "Dominica",
    "lat": 15.414999,
    "lng": -61.370976,
    "summary": "The Nature Island of the Caribbean with lush rainforests and hot springs."
  },
  {
    "id": "dominican-republic",
    "title": "Dominican Republic",
    "lat": 18.7357,
    "lng": -70.1627,
    "summary": "Known for beaches, resorts, and Spanish colonial history."
  },
  {
    "id": "east-timor",
    "title": "East Timor",
    "lat": -8.8742,
    "lng": 125.7275,
    "summary": "Southeast Asian island nation with mountain ranges and coral reefs."
  },
  {
    "id": "ecuador",
    "title": "Ecuador",
    "lat": -1.8312,
    "lng": -78.1834,
    "summary": "Home to the Galápagos Islands and diverse ecosystems."
  },
  {
    "id": "el-salvador",
    "title": "El Salvador",
    "lat": 13.7942,
    "lng": -88.8965,
    "summary": "Central America's smallest country, with volcanoes and surf beaches."
  },
  {
    "id": "equatorial-guinea",
    "title": "Equatorial Guinea",
    "lat": 1.6508,
    "lng": 10.2679,
    "summary": "Oil-rich country with rainforests and coastal plains."
  },
  {
    "id": "eritrea",
    "title": "Eritrea",
    "lat": 15.1794,
    "lng": 39.7823,
    "summary": "Northeast African nation with Red Sea coastline and Italian colonial influence."
  },
  {
    "id": "estonia",
    "title": "Estonia",
    "lat": 58.5953,
    "lng": 25.0136,
    "summary": "Baltic country with medieval architecture and digital innovation."
  },
  {
    "id": "eswatini",
    "title": "Eswatini",
    "lat": -26.5225,
    "lng": 31.4659,
    "summary": "Southern African kingdom known for its nature reserves and culture."
  },
  {
    "id": "ethiopia",
    "title": "Ethiopia",
    "lat": 9.1450,
    "lng": 40.4897,
    "summary": "Land of ancient civilization and rugged landscapes."
  },
  {
    "id": "fiji",
    "title": "Fiji",
    "lat": -17.7134,
    "lng": 178.0650,
    "summary": "South Pacific archipelago with coral reefs and tropical islands."
  },
  {
    "id": "finland",
    "title": "Finland",
    "lat": 61.9241,
    "lng": 25.7482,
    "summary": "Land of lakes, forests, and the Northern Lights."
  },
  {
    "id": "gabon",
    "title": "Gabon",
    "lat": -0.8037,
    "lng": 11.6094,
    "summary": "Central African country with protected parklands and wildlife."
  },
  {
    "id": "gambia",
    "title": "Gambia",
    "lat": 13.4432,
    "lng": -15.3101,
    "summary": "West African country known for its river and Atlantic coastline."
  },
  {
    "id": "georgia",
    "title": "Georgia",
    "lat": 42.3154,
    "lng": 43.3569,
    "summary": "Crossroads of Europe and Asia, known for mountains and wine."
  },
  {
    "id": "ghana",
    "title": "Ghana",
    "lat": 7.9465,
    "lng": -1.0232,
    "summary": "West African nation rich in culture and historical sites."
  },
  {
    "id": "greece",
    "title": "Greece",
    "lat": 39.0742,
    "lng": 21.8243,
    "summary": "Cradle of Western civilization with islands, ruins, and Mediterranean cuisine."
  },
  {
    "id": "grenada",
    "title": "Grenada",
    "lat": 12.1165,
    "lng": -61.6790,
    "summary": "Caribbean island nation known as the 'Spice Isle'."
  },
   {
    "id": "guatemala",
    "title": "Guatemala",
    "lat": 15.7835,
    "lng": -90.2308,
    "summary": "A Central American gem known for its Mayan ruins and volcanoes."
  },
  {
    "id": "guinea",
    "title": "Guinea",
    "lat": 9.9456,
    "lng": -9.6966,
    "summary": "West African country with rich mineral resources and vibrant cultures."
  },
  {
    "id": "guinea-bissau",
    "title": "Guinea-Bissau",
    "lat": 11.8037,
    "lng": -15.1804,
    "summary": "Tropical country with islands, mangroves, and colonial Portuguese history."
  },
  {
    "id": "guyana",
    "title": "Guyana",
    "lat": 4.8604,
    "lng": -58.9302,
    "summary": "South American country with dense rainforests and English-speaking heritage."
  },
  {
    "id": "haiti",
    "title": "Haiti",
    "lat": 18.9712,
    "lng": -72.2852,
    "summary": "Caribbean country with a rich history of independence and cultural expression."
  },
  {
    "id": "honduras",
    "title": "Honduras",
    "lat": 13.2000,
    "lng": -85.6667,
    "summary": "Central American country with beautiful beaches and Mayan ruins."
  },
  {
    "id": "hungary",
    "title": "Hungary",
    "lat": 47.1625,
    "lng": 19.5033,
    "summary": "A landlocked European nation known for thermal baths and historical architecture."
  },
  {
    "id": "iceland",
    "title": "Iceland",
    "lat": 64.9631,
    "lng": -19.0208,
    "summary": "Land of fire and ice, famous for geysers, glaciers, and Northern Lights."
  },
  {
    "id": "indonesia",
    "title": "Indonesia",
    "lat": -0.7893,
    "lng": 113.9213,
    "summary": "World's largest island country, rich in cultures, jungles, and volcanoes."
  },
  {
    "id": "iran",
    "title": "Iran",
    "lat": 32.4279,
    "lng": 53.6880,
    "summary": "Middle Eastern country with Persian heritage and diverse landscapes."
  },
  {
    "id": "iraq",
    "title": "Iraq",
    "lat": 33.2232,
    "lng": 43.6793,
    "summary": "Cradle of civilization with ancient Mesopotamian ruins and rich history."
  },
  {
    "id": "ireland",
    "title": "Ireland",
    "lat": 53.4129,
    "lng": -8.2439,
    "summary": "Emerald Isle known for its green landscapes, folklore, and castles."
  },
  {
    "id": "israel",
    "title": "Israel",
    "lat": 31.0461,
    "lng": 34.8516,
    "summary": "Holy land to many religions with modern cities and ancient ruins."
  },
  {
    "id": "ivory-coast",
    "title": "Ivory Coast",
    "lat": 7.5400,
    "lng": -5.5471,
    "summary": "West African country known for cocoa production and cultural diversity."
  },
  {
    "id": "jamaica",
    "title": "Jamaica",
    "lat": 18.1096,
    "lng": -77.2975,
    "summary": "Caribbean island famous for reggae music, beaches, and vibrant culture."
  },
  {
    "id": "japan",
    "title": "Japan",
    "lat": 36.2048,
    "lng": 138.2529,
    "summary": "Island nation blending ancient tradition with cutting-edge technology."
  },
  {
    "id": "jordan",
    "title": "Jordan",
    "lat": 30.5852,
    "lng": 36.2384,
    "summary": "Middle Eastern country with the historic Petra and desert landscapes."
  },
  {
    "id": "kazakhstan",
    "title": "Kazakhstan",
    "lat": 48.0196,
    "lng": 66.9237,
    "summary": "Central Asia’s largest country with steppes, cities, and Soviet legacy."
  },
  {
    "id": "kenya",
    "title": "Kenya",
    "lat": -0.0236,
    "lng": 37.9062,
    "summary": "East African country famed for its wildlife safaris and Great Rift Valley."
  },
   {
    "id": "kiribati",
    "title": "Kiribati",
    "lat": -3.3704,
    "lng": -168.7340,
    "summary": "A Pacific island nation spread across the equator, known for its atolls and marine biodiversity."
  },
  {
    "id": "kuwait",
    "title": "Kuwait",
    "lat": 29.3759,
    "lng": 47.9774,
    "summary": "A wealthy Gulf country famous for oil exports and modern architecture."
  },
  {
    "id": "kyrgyzstan",
    "title": "Kyrgyzstan",
    "lat": 41.2044,
    "lng": 74.7661,
    "summary": "A Central Asian nation with stunning mountains and nomadic culture."
  },
  {
    "id": "laos",
    "title": "Laos",
    "lat": 19.8563,
    "lng": 102.4955,
    "summary": "A peaceful Southeast Asian country with Buddhist temples and the Mekong River."
  },
  {
    "id": "latvia",
    "title": "Latvia",
    "lat": 56.8796,
    "lng": 24.6032,
    "summary": "A Baltic state with medieval towns, forests, and Art Nouveau architecture."
  },
  {
    "id": "lebanon",
    "title": "Lebanon",
    "lat": 33.8547,
    "lng": 35.8623,
    "summary": "A Middle Eastern country blending history, cuisine, and coastal beauty."
  },
  {
    "id": "lesotho",
    "title": "Lesotho",
    "lat": -29.6099,
    "lng": 28.2336,
    "summary": "A mountainous, landlocked country entirely surrounded by South Africa."
  },
  {
    "id": "liberia",
    "title": "Liberia",
    "lat": 6.4281,
    "lng": -9.4295,
    "summary": "A West African nation with Atlantic beaches and a unique American-Liberian history."
  },
  {
    "id": "libya",
    "title": "Libya",
    "lat": 26.3351,
    "lng": 17.2283,
    "summary": "North African country with ancient ruins and vast desert landscapes."
  },
  {
    "id": "liechtenstein",
    "title": "Liechtenstein",
    "lat": 47.1660,
    "lng": 9.5554,
    "summary": "A tiny Alpine principality between Switzerland and Austria, known for its castles."
  },
  {
    "id": "lithuania",
    "title": "Lithuania",
    "lat": 55.1694,
    "lng": 23.8813,
    "summary": "Baltic country with a rich medieval heritage and vibrant capital, Vilnius."
  },
  {
    "id": "luxembourg",
    "title": "Luxembourg",
    "lat": 49.8153,
    "lng": 6.1296,
    "summary": "Small but wealthy country known for its fortified medieval old town and EU institutions."
  },
  {
    "id": "madagascar",
    "title": "Madagascar",
    "lat": -18.7669,
    "lng": 46.8691,
    "summary": "An island nation off Africa, rich in unique wildlife and biodiversity."
  },
  {
    "id": "malawi",
    "title": "Malawi",
    "lat": -13.2543,
    "lng": 34.3015,
    "summary": "The Warm Heart of Africa, known for its friendly people and Lake Malawi."
  },
  {
    "id": "malaysia",
    "title": "Malaysia",
    "lat": 4.2105,
    "lng": 101.9758,
    "summary": "Southeast Asian country with tropical beaches, rainforests, and a blend of cultures."
  },
  {
    "id": "maldives",
    "title": "Maldives",
    "lat": 3.2028,
    "lng": 73.2207,
    "summary": "An island paradise in the Indian Ocean, famed for luxury resorts and coral reefs."
  },
  {
    "id": "mali",
    "title": "Mali",
    "lat": 17.5707,
    "lng": -3.9962,
    "summary": "A West African country with ancient trading cities like Timbuktu and desert culture."
  },
  {
    "id": "malta",
    "title": "Malta",
    "lat": 35.9375,
    "lng": 14.3754,
    "summary": "A Mediterranean island nation with a rich history and sunny beaches."
  },
  {
    "id": "marshall-islands",
    "title": "Marshall Islands",
    "lat": 7.1315,
    "lng": 171.1845,
    "summary": "Pacific island nation of atolls and marine life, with a unique WWII history."
  },
  {
    "id": "mauritania",
    "title": "Mauritania",
    "lat": 21.0079,
    "lng": -10.9408,
    "summary": "A desert-dominated country in West Africa, blending Arab and African cultures."
  },
   {
    "id": "mauritius",
    "title": "Mauritius",
    "lat": -20.3484,
    "lng": 57.5522,
    "summary": "An island nation in the Indian Ocean known for its beaches, reefs, and multicultural charm."
  },
  {
    "id": "mexico",
    "title": "Mexico",
    "lat": 23.6345,
    "lng": -102.5528,
    "summary": "A vibrant country famous for its cuisine, ancient ruins, and diverse landscapes."
  },
  {
    "id": "micronesia",
    "title": "Micronesia",
    "lat": 7.4256,
    "lng": 150.5508,
    "summary": "A cluster of islands in the Pacific known for its coral atolls and marine culture."
  },
  {
    "id": "moldova",
    "title": "Moldova",
    "lat": 47.4116,
    "lng": 28.3699,
    "summary": "Eastern European country known for its wine, monasteries, and green landscapes."
  },
  {
    "id": "monaco",
    "title": "Monaco",
    "lat": 43.7384,
    "lng": 7.4246,
    "summary": "A glamorous microstate on the French Riviera famous for casinos and luxury yachts."
  },
  {
    "id": "mongolia",
    "title": "Mongolia",
    "lat": 46.8625,
    "lng": 103.8467,
    "summary": "A vast Asian country of steppe, nomads, and historic links to Genghis Khan."
  },
  {
    "id": "montenegro",
    "title": "Montenegro",
    "lat": 42.7087,
    "lng": 19.3744,
    "summary": "A Balkan gem with Adriatic beaches, medieval towns, and rugged mountains."
  },
  {
    "id": "morocco",
    "title": "Morocco",
    "lat": 31.7917,
    "lng": -7.0926,
    "summary": "A North African country with deserts, souks, and vibrant cultural heritage."
  },
  {
    "id": "mozambique",
    "title": "Mozambique",
    "lat": -18.6657,
    "lng": 35.5296,
    "summary": "An East African nation with Indian Ocean beaches and rich marine life."
  },
  {
    "id": "myanmar",
    "title": "Myanmar",
    "lat": 21.9162,
    "lng": 95.9560,
    "summary": "A Southeast Asian country rich in temples, history, and diverse cultures."
  },
  {
    "id": "namibia",
    "title": "Namibia",
    "lat": -22.9576,
    "lng": 18.4904,
    "summary": "A country in southern Africa known for its deserts, wildlife, and vast open spaces."
  },
  {
    "id": "nauru",
    "title": "Nauru",
    "lat": -0.5228,
    "lng": 166.9315,
    "summary": "The third smallest country in the world, located in the Pacific Ocean."
  },
  {
    "id": "nepal",
    "title": "Nepal",
    "lat": 28.3949,
    "lng": 84.1240,
    "summary": "A Himalayan country home to Mount Everest and rich spiritual traditions."
  },
  {
    "id": "netherlands",
    "title": "Netherlands",
    "lat": 52.1326,
    "lng": 5.2913,
    "summary": "A country known for canals, windmills, tulips, and progressive culture."
  },
  {
    "id": "new-zealand",
    "title": "New Zealand",
    "lat": -40.9006,
    "lng": 174.8860,
    "summary": "A stunning island nation with breathtaking landscapes and adventure tourism."
  },
  {
    "id": "nicaragua",
    "title": "Nicaragua",
    "lat": 12.8654,
    "lng": -85.2072,
    "summary": "A Central American nation with lakes, volcanoes, and colonial towns."
  },
  {
    "id": "niger",
    "title": "Niger",
    "lat": 17.6078,
    "lng": 8.0817,
    "summary": "A large West African nation mostly covered by the Sahara desert."
  },
  {
    "id": "nigeria",
    "title": "Nigeria",
    "lat": 9.0820,
    "lng": 8.6753,
    "summary": "Africa’s most populous country, rich in culture, music, and oil resources."
  },
  {
    "id": "north-korea",
    "title": "North Korea",
    "lat": 40.3399,
    "lng": 127.5101,
    "summary": "A secretive nation on the Korean peninsula known for its isolation and regime."
  },
  {
    "id": "north-macedonia",
    "title": "North Macedonia",
    "lat": 41.6086,
    "lng": 21.7453,
    "summary": "A Balkan country with ancient ruins and scenic mountains."
  },
  {
  id: 'panama',
  title: 'Panama',
  lat: 8.537981,
  lng: -80.782127,
  summary: 'A bridge between continents, known for its famous canal and biodiversity.'
},
{
  id: 'papua-new-guinea',
  title: 'Papua New Guinea',
  lat: -6.314993,
  lng: 143.95555,
  summary: 'A land of rich tribal cultures and lush rainforests, located in the Pacific.'
},
{
  id: 'paraguay',
  title: 'Paraguay',
  lat: -23.442503,
  lng: -58.443832,
  summary: 'A heartland of South America with rivers, forests, and cultural heritage.'
},
{
  id: 'peru',
  title: 'Peru',
  lat: -9.189967,
  lng: -75.015152,
  summary: 'Home of Machu Picchu and ancient Incan civilization, rich in culture and landscapes.'
},
{
  id: 'philippines',
  title: 'Philippines',
  lat: 13.41,
  lng: 122.56,
  summary: 'An archipelago of over 7,000 islands with stunning beaches and vibrant culture.'
},
{
  id: 'romania',
  title: 'Romania',
  lat: 45.943161,
  lng: 24.96676,
  summary: 'A land of castles, medieval towns, and the mysterious Transylvania.'
},
{
  id: 'russia',
  title: 'Russia',
  lat: 61.52401,
  lng: 105.318756,
  summary: 'The largest country on Earth, known for its diverse terrain, culture, and history.'
},
{
  id: 'rwanda',
  title: 'Rwanda',
  lat: -1.940278,
  lng: 29.873888,
  summary: 'The "Land of a Thousand Hills," celebrated for its gorillas and resilience.'
},
{
  id: 'saint-vincent-and-the-grenadines',
  title: 'Saint Vincent and the Grenadines',
  lat: 13.252817,
  lng: -61.197162,
  summary: 'A Caribbean gem with volcanic landscapes, beaches, and sailing destinations.'
},
{
  id: 'samoa',
  title: 'Samoa',
  lat: -13.759029,
  lng: -172.104629,
  summary: 'A Polynesian island nation known for its lush greenery and traditional culture.'
},
{
  id: 'san-marino',
  title: 'San Marino',
  lat: 43.9333,
  lng: 12.45,
  summary: 'One of the world’s oldest republics, perched atop hills with medieval charm.'
},
{
  id: 'sao-tome-and-principe',
  title: 'Sao Tome and Principe',
  lat: 0.18636,
  lng: 6.613081,
  summary: 'A small island nation in the Gulf of Guinea, rich in biodiversity and cocoa.'
},
{
  id: 'senegal',
  title: 'Senegal',
  lat: 14.497401,
  lng: -14.452362,
  summary: 'A West African country known for its vibrant music, history, and Atlantic coast.'
},
{
  id: 'serbia',
  title: 'Serbia',
  lat: 44.016521,
  lng: 21.005859,
  summary: 'A Balkan nation with medieval heritage, lively cities, and rich traditions.'
},
{
  id: 'slovenia',
  title: 'Slovenia',
  lat: 46.151241,
  lng: 14.995463,
  summary: 'A green jewel of Europe, offering alpine scenery, lakes, and charming towns.'
},
{
  id: 'solomon-islands',
  title: 'Solomon Islands',
  lat: -9.64571,
  lng: 160.156194,
  summary: 'A Pacific archipelago known for WWII history, coral reefs, and traditional culture.'
},
{
  id: 'somalia',
  title: 'Somalia',
  lat: 5.152149,
  lng: 46.199616,
  summary: 'A Horn of Africa nation with a long coastline, ancient trade history, and resilience.'
},
{
  id: 'south-korea',
  title: 'South Korea',
  lat: 35.907757,
  lng: 127.766922,
  summary: 'A tech-savvy, pop-culture powerhouse with rich traditions and dynamic cities.'
},
{
  id: 'south-sudan',
  title: 'South Sudan',
  lat: 6.8769919,
  lng: 31.3069788,
  summary: 'The world’s youngest nation, rich in cultural diversity and natural landscapes.'
},
{
  id: 'sudan',
  title: 'Sudan',
  lat: 12.862807,
  lng: 30.217636,
  summary: 'A land of ancient pyramids and the confluence of the Blue and White Nile.'
},
{
  id: 'suriname',
  title: 'Suriname',
  lat: 3.919305,
  lng: -56.027783,
  summary: 'A South American country known for its rainforests and Dutch colonial history.'
},
{
  id: 'syria',
  title: 'Syria',
  lat: 34.802075,
  lng: 38.996815,
  summary: 'A cradle of ancient civilizations, currently undergoing recovery and rebuilding.'
},
{
  id: 'taiwan',
  title: 'Taiwan',
  lat: 23.69781,
  lng: 120.960515,
  summary: 'An island nation blending modern cities with mountains, culture, and street food.'
},
{
  id: 'tajikistan',
  title: 'Tajikistan',
  lat: 38.861034,
  lng: 71.276093,
  summary: 'A Central Asian country dominated by mountains and ancient Silk Road heritage.'
},
{
  id: 'tanzania',
  title: 'Tanzania',
  lat: -6.369028,
  lng: 34.888822,
  summary: 'Home to Mount Kilimanjaro, Serengeti safaris, and Zanzibar’s beaches.'
},
{
  id: 'timor-leste',
  title: 'Timor-Leste',
  lat: -8.874217,
  lng: 125.727539,
  summary: 'A young Southeast Asian nation with rugged beauty and Portuguese influence.'
},
{
  id: 'togo',
  title: 'Togo',
  lat: 8.619543,
  lng: 0.824782,
  summary: 'A narrow West African country with beaches, savannah, and vibrant markets.'
},
{
  id: 'tonga',
  title: 'Tonga',
  lat: -21.178986,
  lng: -175.198242,
  summary: 'A Polynesian kingdom of islands known for its traditions and coral reefs.'
},
{
  id: 'trinidad-and-tobago',
  title: 'Trinidad and Tobago',
  lat: 10.691803,
  lng: -61.222503,
  summary: 'A Caribbean duo famed for its Carnival, music, and cultural mix.'
},
{
  id: 'tunisia',
  title: 'Tunisia',
  lat: 33.886917,
  lng: 9.537499,
  summary: 'A North African nation with Mediterranean beaches and ancient Roman ruins.'
},
{
  id: 'turkmenistan',
  title: 'Turkmenistan',
  lat: 38.969719,
  lng: 59.556278,
  summary: 'A Central Asian nation with desert landscapes and the fiery Darvaza gas crater.'
},
{
  id: 'tuvalu',
  title: 'Tuvalu',
  lat: -7.109535,
  lng: 177.64933,
  summary: 'One of the smallest and least visited countries, known for its atolls and marine life.'
},
{
  id: 'uganda',
  title: 'Uganda',
  lat: 1.373333,
  lng: 32.290275,
  summary: 'A landlocked country rich in wildlife, home to the source of the Nile and gorilla trekking.'
},
{
  id: 'ukraine',
  title: 'Ukraine',
  lat: 48.379433,
  lng: 31.16558,
  summary: 'A country of resilient spirit, vast plains, and a rich cultural heritage in Eastern Europe.'
},
{
  id: 'uruguay',
  title: 'Uruguay',
  lat: -32.522779,
  lng: -55.765835,
  summary: 'A peaceful South American country with beaches, colonial towns, and progressive values.'
},
{
  id: 'uzbekistan',
  title: 'Uzbekistan',
  lat: 41.377491,
  lng: 64.585262,
  summary: 'A Silk Road gem with magnificent Islamic architecture and desert cities like Samarkand.'
},
{
  id: 'vanuatu',
  title: 'Vanuatu',
  lat: -15.376706,
  lng: 166.959158,
  summary: 'A Pacific island nation offering volcano treks, coral reefs, and vibrant island culture.'
},
{
  id: 'vatican-city',
  title: 'Vatican City',
  lat: 41.9029,
  lng: 12.4534,
  summary: 'The smallest country in the world, spiritual hub of the Roman Catholic Church.'
},
{
  id: 'venezuela',
  title: 'Venezuela',
  lat: 6.42375,
  lng: -66.58973,
  summary: 'A country of dramatic landscapes, from the Andes to Angel Falls, the world’s highest waterfall.'
},
{
  id: 'yemen',
  title: 'Yemen',
  lat: 15.552727,
  lng: 48.516388,
  summary: 'A nation with ancient history and unique architecture, currently facing humanitarian challenges.'
},
{
  id: 'zambia',
  title: 'Zambia',
  lat: -13.133897,
  lng: 27.849332,
  summary: 'Known for Victoria Falls and abundant wildlife, Zambia offers classic African safaris.'
},
{
  id: 'zimbabwe',
  title: 'Zimbabwe',
  lat: -19.015438,
  lng: 29.154857,
  summary: 'A land of ancient ruins, spectacular waterfalls, and diverse landscapes.'
}
];

export default globeDestinations;